import { render, staticRenderFns } from "./bookingPost.vue?vue&type=template&id=2de8f6b2&"
import script from "./bookingPost.vue?vue&type=script&lang=js&"
export * from "./bookingPost.vue?vue&type=script&lang=js&"
import style0 from "./bookingPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports